export enum GroupTeacherTabSortKeyEnum {
  NAME = 'name',
  EMAIL = 'email',
  MOBILE_PHONE = 'mobilePhone',
  STATUS = 'status'
}

export enum EventTypeEnum {
  DAILY_CHANGABLE = 'Daily changeable',
  FIXED = 'Fixed'
}

export enum GroupChildrenTabSortKeyEnum {
  NAME = 'name',
  PARENTS = 'parents',
  MEMBERSHIP = 'membership',
  STATUS = 'status'
}
